import { env } from '@/config/env';
import { TOKEN_STORAGE_KEY } from '@/core/auth/types';

/** Attribution shown on maps served from Trimble's basemap. */
export const TRIMBLE_ATTRIBUTION = '&copy; Trimble Maps';

export const OSM_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

/**
 * Leaflet URL template for the API's Trimble tile proxy, or `null` when there
 * is no token to authenticate with — callers fall back to OpenStreetMap rather
 * than render an empty grid.
 *
 * Proxied rather than called directly because the PC*MILER key must not reach
 * the browser: the same key can create and delete trips on the account. The
 * token rides in the query string because Leaflet loads tiles as plain `<img>`
 * elements, which cannot carry an Authorization header; the API accepts it
 * there for this one route only.
 *
 * PC*MILER's tile grid is standard Web Mercator XYZ — verified against the live
 * service, where the y-flipped (TMS) and open-ocean tiles both come back as the
 * same 591-byte empty tile while the correct XYZ tile is ~44 KB. So Leaflet's
 * default scheme needs no adjustment.
 */
export function trimbleTileUrl(mode: 'light' | 'dark' = 'light'): string | null {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token === null || token === '' || env.apiBaseUrl === '') return null;
  // Trimble ships a night basemap; without it a dark-themed page renders a
  // bright white rectangle in the middle of the panel.
  const style = mode === 'dark' ? '&style=Night' : '';
  return (
    `${env.apiBaseUrl}/api/v1/Routes/MapTile` +
    `?z={z}&x={x}&y={y}${style}&access_token=${encodeURIComponent(token)}`
  );
}
